<div *ngIf="!loading" class="app-container-content">
  <ng-container *ngIf="!isAuth" class="login-container-no-auth">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-container *ngIf="isAuth">
    <!-- Header -->
    <app-header-toolbar
      (toggleSidenav)="onToggleSidenav()"
      [heading]="userEmail"
      [userEmail]="userEmail"
      [showSearch]="showSearch"
      [showNotifications]="showNotifications"
      class="header-toolbar"
    ></app-header-toolbar>

    <!-- Main Layout -->
    <app-main-layout
      [showAnalytics]="showAnalytics"
      [showPrompts]="showPrompts"
      [chatMenuTitle]="chatMenuTitle"
    >
    </app-main-layout>
  </ng-container>
</div>

<div *ngIf="loading" class="loading-container">
  <app-header></app-header>
  <app-loading-spinner [diameter]="40" [loadingText]="'Loading...'" [fullPage]="false"></app-loading-spinner>
</div>
